export const EMPLOYEETAX_LOADING = "EMPLOYEETAX_LOADING";
export const EMPLOYEETAX_RESET = "EMPLOYEETAX_RESET";
export const GET_EMPLOYEETAX = "GET_EMPLOYEETAX";
export const GET_EMPLOYEETAX_SUCCESS = "GET_EMPLOYEETAX_SUCCESS";
export const GET_EMPLOYEETAX_FAIL = "GET_EMPLOYEETAX_FAIL";
export const DELETE_EMPLOYEETAX = "DELETE_EMPLOYEETAX"
export const DELETE_EMPLOYEETAX_SUCCESS = "DELETE_EMPLOYEETAX_SUCCESS"
export const DELETE_EMPLOYEETAX_FAIL = "DELETE_EMPLOYEETAX_FAIL"
export const UPDATE_EMPLOYEETAX = "UPDATE_EMPLOYEETAX"
export const UPDATE_EMPLOYEETAX_SUCCESS = "UPDATE_EMPLOYEETAX_SUCCESS"
export const UPDATE_EMPLOYEETAX_FAIL = "UPDATE_EMPLOYEETAX_FAIL"
export const ADD_NEW_EMPLOYEETAX = "ADD_NEW_EMPLOYEETAX"
export const ADD_EMPLOYEETAX_SUCCESS = "ADD_EMPLOYEETAX_SUCCESS"
export const ADD_EMPLOYEETAX_FAIL = "ADD_EMPLOYEETAX_FAIL"